import { useState } from 'react'
import { useRequest } from 'ahooks'

import { Expand } from 'components'
import { Table } from '@sar/component'

import { Input, Row, Col, Popover } from 'antd'
import { ModalForm, ProFormItem, ProFormText, ProFormDigit, ProFormRadio, ProFormSwitch, ProFormTreeSelect, ProFormDependency } from '@ant-design/pro-components'

async function fetchData(store) {
  const result = await store.externals.api.get('/menu/0/children')

  return {
    success: true,
    data: result,
  }
}

function Icons({ onChange, onClose }) {
  const icons = [
    'address-book',
    'address-book-o',
    'address-card',
    'address-card-o',
    'bandcamp',
    'bath',
    'id-card',
    'id-card-o',
    'envelope-open',
    'envelope-open-o',
    'user',
    'user-o',
    'user-circle',
    'user-circle-o',
    'bell',
    'bell-o',
    'bell-slash',
    'bell-slash-o',
    'book',
    'cog',
    'cogs',
    'comment',
    'comment-o',
    'commenting',
    'commenting-o',
    'tag',
    'tags',
    'trash',
    'trash-o',
    'bars',
    'code',
    'calendar',
    'medkit',
    'inbox',
    'pencil-square',
    'pencil-square-o',
  ]

  return <Row gutter={[4, 8]} className='w-[650px] max-h-96 overflow-y-auto'>
    {icons.map(icon => {
      return <Col
        xs={8}
        key={icon}
        onClick={() => Promise.resolve(onChange(icon)).then(onClose)}
      >
        <div className='text-gray-800 text-lg flex items-center cursor-pointer hover:text-blue-800'>
          <div className='w-8 flex justify-center'>
            <i className={`fa fa-${icon}`}></i>
          </div>
          <div>{icon}</div>
        </div>
      </Col>
    })}
  </Row>
}

function Create ({ store, visible, handles, onVisibleChange }) {
  const MenuType = React.useMemo(() => {
    return store.config.getConstantPairs('MenuType')
  }, [])

  return <ModalForm
    title='新建菜单'
    layout='vertical'
    grid={true}
    width={600}
    open={visible}
    initialValues={{
      type: '0',
      menuSort: 999,
    }}
    modalProps={{
      centered:true,
      maskClosable: false,
      destroyOnClose: true
    }}
    onOpenChange={onVisibleChange}
    onFinish={params => store.externals.api.post('/menu', params).then(() => handles.current.reload()).then(R.T)}
  >
    <ProFormDependency name={['type']}>
      {({ type }) => {
        return <ProFormRadio.Group
          name='type'
          label='菜单类型'
          colProps={{ xs: type == 2 ? 12 : 24 }}
          valueEnum={store.config.getConstantEnums('MenuType')}
          fieldProps={{
            optionType: 'button',
            buttonStyle: 'solid',
          }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type != MenuType.button) {
          return null
        }

        return <ProFormText
          name='title'
          label='按钮名称'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入按钮名称' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <Col xs={24}>
          <ProFormItem name='icon' label='菜单图标'>
            {React.createElement(({ value, onChange }) => {
              const [ open, dispatch ] = useState(false)

              return <Popover
                trigger='click'
                open={open}
                content={(
                  <Icons
                    onChange={onChange}
                    onClose={() => dispatch(false)}
                  />
                )}
                onOpenChange={e => dispatch(e)}
              >
                <Input
                  placeholder='点击选择菜单图标'
                  allowClear
                  value={value}
                  onChange={e => onChange(e.target.value)}
                  prefix={value ? <i className={`fa fa-${value}`}/> : <i />}
                />
              </Popover>
            })}
          </ProFormItem>
        </Col>
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormSwitch
          name='iFrame'
          label='外链菜单'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type != MenuType.menu) {
          return null
        }

        return <ProFormSwitch
          name='cache'
          label='菜单缓存'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormSwitch
          name='hidden'
          label='隐藏菜单'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormText
          name='title'
          label='菜单标题'
          colProps={{ xs: type == 1 ? 12 : 24 }}
          rules={[ { required: true, message: '请输入菜单名称' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        return <ProFormText
          name='permission'
          label='权限标识'
          colProps={{ xs: 12 }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormText
          name='path'
          label='路由地址'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入路由地址' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDigit
      name='menuSort'
      label='菜单排序'
      min={0}
      fieldProps={{ precision: 0 }}
      colProps={{ xs: 12 }}
    />

    <ProFormTreeSelect
      name='pid'
      label='上级类目'
      request={() => store.externals.api.get(`/menu/build`)}
      fieldProps={{ fieldNames: { value: 'id', label: 'title' } }}
    />
  </ModalForm>
}

function Update ({ data, store, visible, handles, onVisibleChange }) {
  const MenuType = React.useMemo(() => {
    return store.config.getConstantPairs('MenuType')
  }, [])

  return <ModalForm
    title='修改菜单'
    layout='vertical'
    grid={true}
    width={600}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true
    }}
    onOpenChange={onVisibleChange}
    request={() => store.externals.api.get(`/menu/${data.id}`)}
    onFinish={params => store.externals.api.put(`/menu/${data.id}`, params).then(() => handles.current.reload()).then(() => onVisibleChange(false)).then(R.T)}
  >
    <ProFormDependency name={['type']}>
      {({ type }) => {
        return <ProFormRadio.Group
          name='type'
          label='菜单类型'
          convertValue={data => data?.toString()}
          colProps={{ xs: type == 2 ? 12 : 24 }}
          valueEnum={store.config.getConstantEnums('MenuType')}
          fieldProps={{
            optionType: 'button',
            buttonStyle: 'solid',
          }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type != MenuType.button) {
          return null
        }

        return <ProFormText
          name='title'
          label='按钮名称'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入按钮名称' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <Col xs={24}>
          <ProFormItem name='icon' label='菜单图标'>
            {React.createElement(({ value, onChange }) => {
              const [ open, dispatch ] = useState(false)

              return <Popover
                trigger='click'
                open={open}
                content={(
                  <Icons
                    onChange={onChange}
                    onClose={() => dispatch(false)}
                  />
                )}
                onOpenChange={e => dispatch(e)}
              >
                <Input
                  placeholder='点击选择菜单图标'
                  allowClear
                  value={value}
                  prefix={value ? <i className={`fa fa-${value}`}/> : <i />}
                />
              </Popover>
            })}
          </ProFormItem>
        </Col>
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormSwitch
          name='iFrame'
          label='外链菜单'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type != MenuType.menu) {
          return null
        }

        return <ProFormSwitch
          name='cache'
          label='菜单缓存'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormSwitch
          name='hidden'
          label='隐藏菜单'
          colProps={{ xs: 8 }}
          fieldProps={{ checkedChildren: '是', unCheckedChildren: '否' }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormText
          name='title'
          label='菜单标题'
          colProps={{ xs: type == 1 ? 12 : 24 }}
          rules={[ { required: true, message: '请输入菜单名称' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        return <ProFormText
          name='permission'
          label='权限标识'
          colProps={{ xs: 12 }}
        />
      }}
    </ProFormDependency>

    <ProFormDependency name={['type']}>
      {({ type }) => {
        if(type == MenuType.button) {
          return null
        }

        return <ProFormText
          name='path'
          label='路由地址'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入路由地址' } ]}
        />
      }}
    </ProFormDependency>

    <ProFormDigit
      name='menuSort'
      label='菜单排序'
      min={0}
      fieldProps={{ precision: 0 }}
      colProps={{ xs: 12 }}
    />

    <ProFormTreeSelect
      name='pid'
      label='上级类目'
      request={() => store.externals.api.get(`/menu/build`)}
      fieldProps={{ fieldNames: { value: 'id', label: 'title' } }}
    />
  </ModalForm>
}

export default function ({ store }) {
  const handles = React.useRef<any>()

  const [ data, dispatch ] = React.useState({
    dataSource: [],
    expandedKeys: [],
  })

  const columns = [
    {
      title: '菜单标题',
      dataIndex: 'title',
      hideInSearch: true,
    },
    {
      title: '排序',
      dataIndex: 'menuSort',
      hideInSearch: true,
    },
    {
      title: '图标',
      dataIndex: 'icon',
      hideInSearch: true,
      render: data => data == null || data == '-' ? null : <i className={`fa fa-${data}`}/>,
    },
    {
      title: '权限标识',
      dataIndex: 'permission',
      hideInSearch: true,
    },
    {
      title: '路由',
      dataIndex: 'path',
      hideInSearch: true,
    },
    {
      title: '创建日期',
      dataIndex: 'createTime',
      valueType: 'datetime',
      hideInSearch: true,
    },
  ]

  const actions = [
    {
      name: '新增',
      type: 'trigger',
      form: props => <Create {...props} store={store} />,
      visible: () => store.identity.hasPermission('/system/menus:create'),
    },
  ]

  const rowActions = [
    {
      name: '修改',
      form: props => <Update {...props} store={store} />,
      visible: () => store.identity.hasPermission('/system/menus:update'),
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这条数据吗？',
      visible: () => store.identity.hasPermission('/system/menus:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/menu/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  return <div className='p-4'>
    <Table
      title='菜单管理'
      rowKey='id'
      search={false}
      pagination={false}
      handles={handles}
      rowActions={rowActions}
      actions={actions}
      columns={columns}
      dataSource={data.dataSource}
      expandedRowKeys={data.expandedKeys}
      expandIcon={(params) => {
        const props = Object.assign(params, {
          store,
          dataSource: data.dataSource,
          service: `/menu/:id/children`,
        })

        return <Expand {...props}/>
      }}
      request={() => fetchData(store)}
      onLoad={e => dispatch({ dataSource: e, expandedKeys: [] })}
      onExpandedRowsChange={e => dispatch({ dataSource: data.dataSource, expandedKeys: e })}
    />
  </div>
}
